import Box from '@mui/material/Box';

import { ConnectionButton, ChannelStepLayout } from 'src/pages/channel/shared';

import { Form, Field } from 'src/components/hook-form';

import { useInstagramStep2 } from '../hooks/useInstagramStep2';

export function InstagramStep2() {
  const {
    t,
    methods,
    isNextDisabled,
    isConnectDisabled,
    isInstagramConnectSuccess,
    connect,
    onSubmit,
  } = useInstagramStep2();

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ChannelStepLayout title="" isNextDisabled={isNextDisabled}>
        <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Channel Name */}
          <Field.Text
            name="channelName"
            label={t('CHANNEL_NAME')}
            placeholder={t('ENTER_CHANNEL_NAME_PLACEHOLDER')}
            fullWidth
            InputLabelProps={{ shrink: true }}
            slotProps={{
              input: {
                sx: {
                  borderRadius: 1,
                  '&:focus-within': {
                    borderColor: 'primary.main',
                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.1)',
                  },
                },
              },
            }}
          />

          {/* Instagram Connect */}
          <Box sx={{ mt: 2 }}>
            <ConnectionButton
              label={`${t('SIGN_IN_WITH')} ${t('INSTAGRAM')}`}
              icon="mdi:instagram"
              onClick={connect}
              disabled={isConnectDisabled}
              isConnected={isInstagramConnectSuccess}
              successMessage={t('ACCOUNT_VERIFIED')}
            />
          </Box>
        </Box>
      </ChannelStepLayout>
    </Form>
  );
}
